import React, { useEffect } from "react";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "App.css";
import { useAuth } from "components/shared/AuthProvider";
import { ThemeProvider } from "components/shared/ThemeProvider";
import ScrollToTop from "components/shared/ScrollToTop";
import LoadingPage from "components/shared/LoadingPage";
import AnonymousLayout from "components/layout/AnonymousLayout";
import AuthenticatedLayout from "components/layout/AuthenticatedLayout";
import NoConnectionError from "components/exception/NoConnectionError";
import PushNotificationService from "services/PushNotificationService";

const AppContent = () => {
    const { isAuthenticated, isLoading, hasConnection } = useAuth();

    // Initialize push notifications once when app loads
    useEffect(() => {
        if (isLoading === false && hasConnection) {
            const pushNotificationService = new PushNotificationService();
            pushNotificationService.initialize();

            // Resend device token on app launch if already authenticated
            if (isAuthenticated) {
                pushNotificationService.saveStoredTokenIfAuthenticated();
            }

            return () => {
                pushNotificationService.removeAllListeners();
            };
        }
    }, [hasConnection, isLoading, isAuthenticated]);

    // Re-associate device token when user authenticates
    useEffect(() => {
        if (isAuthenticated && hasConnection) {
            const pushNotificationService = new PushNotificationService();
            pushNotificationService.saveStoredTokenIfAuthenticated();
        }
    }, [isAuthenticated, hasConnection]);

    if (isLoading) {
        return (
            <>
                <LoadingPage />
                <ToastContainer />
            </>
        );
    }

    if (!hasConnection) {
        return (
            <>
                <NoConnectionError />
                <ToastContainer />
            </>
        );
    }

    return (
        <>
            {isAuthenticated ? <AuthenticatedLayout /> : <AnonymousLayout />}
            <ToastContainer />
        </>
    );
};

const App = () => {
    return (
        <ThemeProvider>
            <ScrollToTop />
            <AppContent />
        </ThemeProvider>
    );
};

export default App;
